"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var executeIfNotProduction = function executeIfNotProduction(func) {
  if (process.env.NODE_ENV !== 'production') {
    func();
  }
};

var logError = function logError(message) {
  executeIfNotProduction(function () {
    console.error("Error: ".concat(message)); // tslint:disable-line
  });
};

exports.logError = logError;

var logWarning = function logWarning(message) {
  executeIfNotProduction(function () {
    console.warn("Warning: ".concat(message)); // tslint:disable-line
  });
};

exports.logWarning = logWarning;